module.exports = __webpack_public_path__ + "img/pen.7e73cc59.svg";